import { render, staticRenderFns } from "./TableEvaluatedCategories.vue?vue&type=template&id=7497f2b4&"
import script from "./TableEvaluatedCategories.vue?vue&type=script&lang=js&"
export * from "./TableEvaluatedCategories.vue?vue&type=script&lang=js&"
import style0 from "./TableEvaluatedCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports